<template>
  <section>
    <h2 class="h2Title">선물 관리 세부 설정</h2>
    <div class="dashWrap">
      <div class="dashRow">
        <div class="dashBx">
          <v-tabs>
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#tab-1">
              <v-icon>mdi-file-edit</v-icon>
              기본정보 설정
            </v-tab>

            <v-tab href="#tab-2" :disabled="!id">
              <v-icon>mdi-account-star-outline</v-icon>
              대상 설정
            </v-tab>
            <v-tab href="#tab-3" :disabled="!id">
              <v-icon>mdi-message-bulleted</v-icon>
              알림 내역
            </v-tab>
            <v-tab href="#tab-4" :disabled="!id">
              <v-icon>mdi-text-box-search</v-icon>
              신청 내역
            </v-tab>

            <v-tab-item value="tab-1" key="1">
              <h2 class="tit arrowLink d-flex align-center justify-space-between">
              </h2>

              <basic-component :present-id="id"/>

            </v-tab-item>
            <v-tab-item value="tab-2" key="2">
              <h2 class="tit arrowLink d-flex align-center justify-space-between">
              </h2>

              <member-component :id="id" />
            </v-tab-item>
            <v-tab-item value="tab-3" key="3">
              <h2 class="tit arrowLink d-flex align-center justify-space-between">
              </h2>

              <sms-history :group-id="id" :present="true"/>
            </v-tab-item>
            <v-tab-item value="tab-4" key="4">
              <h2 class="tit arrowLink d-flex align-center justify-space-between">
              </h2>

<!--              <order-component :id="id" />-->
              <component :is="orderComponentType" :id="id" :order-id="orderId" @callback-type="changeOrderComponent"/>
            </v-tab-item>
          </v-tabs>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
import BasicComponent from "./tabs/Basic"
import MemberComponent from "@/views/present/tabs/Member"
import OrderComponent from "@/views/present/tabs/Order"
import OrderFormComponent from "@/views/present/tabs/OrderForm"
import SmsHistory from "@/views/sms/SmsHistory";
export default {
  name: "PresentForm",
  props: ['id'],
  components: {
    BasicComponent,
    MemberComponent,
    OrderComponent,
    OrderFormComponent,
    SmsHistory
  },
  data: () => ({
    orderComponentType: "OrderComponent",
    orderId: null
  }),
  methods: {
    changeOrderComponent(param) {
      if(param.type === 'form') {
        this.orderId = param.orderId
        this.orderComponentType = 'OrderFormComponent'
      } else
        this.orderComponentType = 'OrderComponent'
    }
  },
  created() {
  }

}
</script>